"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.c = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../requests/graphql");
const dispatchers_1 = require("../../../utility/dispatchers");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const Form_1 = require("./Form");
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
exports.c = {
    row: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.fullWidth} ${layout_css_1.default.gutter15}`,
    stat: `${layout_css_1.default.flexColumn} ${layout_css_1.default.marginBottom20}`,
    statLabel: `${typography_css_1.default.bodyS} ${typography_css_1.default.pebble} ${typography_css_1.default.bold}`,
    statValue: `${typography_css_1.default.h3Responsive} ${typography_css_1.default.bold} ${typography_css_1.default.textCenter}`,
};
const Stats = ({ giveawayId }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [stats, setStats] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        (0, graphql_1.graphQuery)({ t: 'get_giveaway_stats' }, { giveaway_id: giveawayId })
            .then((res) => {
            setStats(res.giveaway_stats);
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Get giveaway stats: ', err);
            return;
        })
            .finally(() => setIsLoading(false));
    }, [giveawayId]);
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("p", { className: Form_1.c.subHeader }, "Stats"),
        react_1.default.createElement("div", { className: Form_1.c.form }, isLoading
            ? (react_1.default.createElement("div", { className: exports.c.row }, "Loading stats..."))
            : stats
                ? (react_1.default.createElement("div", { className: exports.c.row },
                    react_1.default.createElement("div", { className: exports.c.stat },
                        react_1.default.createElement("div", { className: exports.c.statLabel }, "Total Registrations"),
                        react_1.default.createElement("div", { className: exports.c.statValue }, stats.registration_count)),
                    react_1.default.createElement("div", { className: exports.c.stat },
                        react_1.default.createElement("div", { className: exports.c.statLabel }, "Total Earned Entries"),
                        react_1.default.createElement("div", { className: exports.c.statValue }, stats.total_entries)),
                    react_1.default.createElement("div", { className: exports.c.stat },
                        react_1.default.createElement("div", { className: exports.c.statLabel }, "Most Popular Prize Preference"),
                        react_1.default.createElement("div", { className: exports.c.statValue }, stats.most_popular_prize_preference || 'N/A')),
                    react_1.default.createElement("div", { className: exports.c.stat },
                        react_1.default.createElement("div", { className: exports.c.statLabel }, "Non-Registration Surveys Completed"),
                        react_1.default.createElement("div", { className: exports.c.statValue }, stats.non_registration_surveys_completed.length === 0
                            ? ('None')
                            : (react_1.default.createElement("ul", { className: util_css_1.default.ulReset }, stats.non_registration_surveys_completed.map((survey) => (react_1.default.createElement("li", { key: survey.survey_slug },
                                survey.survey_slug,
                                ":",
                                ' ',
                                survey.completed_count)))))))))
                : (react_1.default.createElement("div", { className: exports.c.row }, "No stats available")))));
};
exports.default = Stats;
